import type { ReactElement } from "react";
import { useMemo } from "react";

import type { ICategory } from "app/common/services/categoryService.types";
import type { IDropDownExtendedItem } from "app/pages/sales-intelligence/common-components/dropdown/ControlledMultiDropdown";
import { renderHighlightedOption } from "app/pages/sales-intelligence/common-components/dropdown/utils/renderHighlightedOption";
import { SelectCombobox } from "app/pages/sales-intelligence/common-components/dropdown/SelectCombobox";

type IosCategoriesDropdownProps = {
    items: readonly IDropDownExtendedItem[];
    selectedItems: readonly ICategory["id"][];
    placeholder: string;
    searchTerm: string;
    buttonText: string;
    onSelect: (item: IDropDownExtendedItem) => void;
    onSearchChange: (value: string) => void;
    renderButton?: () => ReactElement;
};

const IosCategoriesDropdown = ({
    items,
    selectedItems,
    placeholder,
    buttonText,
    searchTerm,
    onSelect,
    onSearchChange,
    renderButton,
}: IosCategoriesDropdownProps) => {
    const selectedIdSet = useMemo(() => new Set(selectedItems.map(String)), [selectedItems]);

    return (
        <SelectCombobox<IDropDownExtendedItem>
            items={items}
            isItemSelected={(item) => selectedIdSet.has(String(item.id))}
            onSelect={onSelect}
            buttonText={buttonText}
            renderButton={renderButton}
            hasSearch
            searchPlaceHolder={placeholder}
            searchValue={searchTerm}
            onSearchChange={onSearchChange}
            renderOption={(item, isSelected) => renderHighlightedOption(item, isSelected, searchTerm)}
        />
    );
};

export default IosCategoriesDropdown;
